import { ScoreDisplay } from './ScoreDisplay';
import { Sidebar } from './Sidebar';
import { GuessInput } from './GuessInput';
import { ToastList } from './ToastList';
import { DebugMenu } from './DebugMenu';
import { CreditsMenu } from './CreditsMenu';
import { WorldCanvas } from './three/WorldCanvas';
import { ContinentPanel } from './ContinentPanel';

export function App() {
    return (
        <>
            <WorldCanvas />
            <ContinentPanel />
            <ScoreDisplay />
            <Sidebar />
            <GuessInput />
            <ToastList />
            <DebugMenu />
            <CreditsMenu />
        </>
    );
}
